import React from "react";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import { UseFieldArrayAppend, UseFieldArrayRemove, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
	StockAdjustmentApi,
	StockAdjustmentItemApi,
} from "../../../../../../../../../../../services/Api/Organization/types";

interface Props {
	remove: UseFieldArrayRemove;
	watchedItems: StockAdjustmentItemApi[];
	form: UseFormReturn<StockAdjustmentApi>;
	append: UseFieldArrayAppend<StockAdjustmentApi, "items">;
	replace: UseFieldArrayAppend<StockAdjustmentApi, "items">;
}

const StockAdjustmentItemsTableActions = ({ remove, watchedItems, form, append, replace }: Props) => {
	const { t } = useTranslation();
	const { getValues } = form;

	const handleRemoveItemsWithNoQuantity = () => {
		const indexes: number[] = [];
		watchedItems.forEach((item, index) => {
			if (!item.quantity) indexes.push(index);
		});
		remove(indexes);

		if (getValues("items").length === 0) {
			append({ position: 0, type: "INCOME" });
		}
	};

	const handleRemoveDuplicatedItems = () => {
		const indexes: number[] = [];
		const uniqueItems: StockAdjustmentItemApi[] = [];
		watchedItems.forEach((item, index) => {
			const existingItem = uniqueItems.find((x) => x?.product?.name === item?.product?.name);
			if (existingItem) indexes.push(index);
			else uniqueItems.push(item);
		});
		remove(indexes);
	};

	const handleSortItemsAlphabetically = () => {
		const newItems = [...watchedItems];
		const sortedItems = newItems.sort((a, b) => a.product?.name.localeCompare(b?.product?.name));
		replace(sortedItems);
	};

	return (
		<Dropdown as={ButtonGroup}>
			<Dropdown.Toggle className="btn-light">{t("common.action.more", { ns: "lib" })}</Dropdown.Toggle>
			<Dropdown.Menu>
				<Dropdown.Item onClick={handleRemoveItemsWithNoQuantity}>
					{t("common.action.remove_items_with_no_quantity")}
				</Dropdown.Item>
				<Dropdown.Item onClick={handleRemoveDuplicatedItems}>
					{t("common.action.remove_duplicated_items")}
				</Dropdown.Item>
				<Dropdown.Item onClick={handleSortItemsAlphabetically}>
					{t("common.action.sort_by_names")}
				</Dropdown.Item>
			</Dropdown.Menu>
		</Dropdown>
	);
};

export default StockAdjustmentItemsTableActions;
